import React from 'react'
import {useTpaSuppressionData} from 'hec/context/tpa-config'
import {isPreviewing, isEditing} from '@builder.io/sdk-react'
import {PreviewContainer} from './previewContainer'
import {
    commonRoleBasedContentInputs,
    commonRoleBasedContentPropTypes,
    getDefaultChildren
} from './utils'

const accessType = 'LMN Suppressed'

export const LmnSuppressedContent = ({
    children,
    hideInEdit
}: React.PropsWithChildren<{hideInEdit?: boolean}>) => {
    const {shouldSuppressContent} = useTpaSuppressionData()

    const isPreview = isPreviewing()
    const isEdit = isEditing()
    if (isPreview) {
        return (
            <PreviewContainer type={accessType} data-testid="lmnSuppressedContent-LoadingContainer">
                Loading TPA context...
            </PreviewContainer>
        )
    }
    const renderContent = () => {
        if ((!shouldSuppressContent && !isEdit) || (isEdit && hideInEdit)) {
            return null
        }
        if (isEdit) {
            return (
                <PreviewContainer
                    type={accessType}
                    data-testid="lmnSuppressedContent-PreviewContainer"
                >
                    {children}
                </PreviewContainer>
            )
        }
        return children
    }

    return renderContent()
}

LmnSuppressedContent.propTypes = {
    ...commonRoleBasedContentPropTypes
}

export const LmnSuppressedContentDefinition = {
    component: LmnSuppressedContent,
    name: 'LmnSuppressedContent',
    canHaveChildren: true,
    image: 'https://unpkg.com/lucide-static@0.537.0/icons/calendar-off.svg',
    noWrap: true,
    defaultChildren: getDefaultChildren(accessType),
    inputs: [...commonRoleBasedContentInputs]
}
